<div class="p-4 side sidebar-container" [ngClass]="toggleOpen ? 'open' : 'closed'"
  style="position: fixed; left: 0px; top: 60px" (mouseenter)="toggleOpen = !toggleOpen"
  (mouseleave)="toggleOpen = !toggleOpen">
  <div class="row justify-content-center my-2 mb-4">
    <i [ngClass]="!toggleOpen ? 'fak fa-bars-close fa-lg' : 'fak fa-bars-open fa-lg'"></i>
  </div>

  <!-- PROJETOS -->
  <ng-container *appCan="'projects:read'">
    <div class="row my-2 justify-content-center">
      <button [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
        routerLink="/projects" routerLinkActive="active-link">
        <i class="fa-regular fa-file-lines" style="width: 30px"></i>
        {{ toggleOpen ? ' Projetos' : '' }}
      </button>
    </div>
  </ng-container>

  <!-- MARCAÇÕES (regions OU areas OU routes) -->
  <ng-container *appCan="'regions|areas|routes:read'">
    <div class="row my-2 justify-content-center">
      <button [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
        routerLink="/region-area" routerLinkActive="active-link">
        <i class="fa-regular fa-map" style="width: 30px"></i>
        {{ toggleOpen ? ' Marcações' : '' }}
      </button>
    </div>
  </ng-container>

  <!-- TRAJETOS -->
  <ng-container *ngIf="org?.paths">
    <div class="row my-2 justify-content-center">
      <button [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
        routerLink="/paths" routerLinkActive="active-link" *appCan="'paths:read'">
        <div class="d-flex align-items-center" [ngStyle]="{ width: toggleOpen ? '30px' : '20px' }">
          <div class="path-icon">KM</div>
        </div>
        {{ toggleOpen ? ' Trajetos' : '' }}
      </button>
    </div>
  </ng-container>

  <!-- ESTOQUE -->
  <ng-container *appCan="'stock:read'">
    <div class="row my-2 justify-content-center">
      <button [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
        routerLink="/stock" routerLinkActive="active-link">
        <i class="fa-regular fa-box-open" style="width: 30px"></i>
        {{ toggleOpen ? ' Estoque' : '' }}
      </button>
    </div>
  </ng-container>

</div>